import RPCClient from './client';
import Keystore from './libs/keystore';
import Bp from './libs/bp';
export default class CQL {
    constructor(apiNodeEndpoint, options) {
        this.options = options;
        this.client = new RPCClient(apiNodeEndpoint);
        this.bp = new Bp(this.client);
        this.keystore = new Keystore();
    }
    async connect() {
        return await this.client.connect();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxTQUF3QixNQUFNLFVBQVUsQ0FBQTtBQUMvQyxPQUFPLFFBQVEsTUFBTSxpQkFBaUIsQ0FBQTtBQUN0QyxPQUFPLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFMUIsTUFBTSxDQUFDLE9BQU8sT0FBTyxHQUFHO0lBTXRCLFlBQ0UsZUFBdUIsRUFDdkIsT0FBZ0I7UUFFaEIsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUE7UUFDdEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLFNBQVMsQ0FBQyxlQUFlLENBQUMsQ0FBQTtRQUM1QyxJQUFJLENBQUMsRUFBRSxHQUFHLElBQUksRUFBRSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUM3QixJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksUUFBUSxFQUFFLENBQUE7SUFDaEMsQ0FBQztJQUVNLEtBQUssQ0FBQyxPQUFPO1FBQ2xCLE9BQU8sTUFBTSxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sRUFBRSxDQUFBO0lBQ3BDLENBQUM7Q0FDRiJ9